import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Role, RoleSearchingCriteria, RoleType } from '@app/models/role';



export const itemOne: any = {
    createdUserId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
    createdUserUsername: "superadmin",
    createdUserFullname: "Super Admin",
    createdUserEmail: "superadmin@cityline.com.hk",
    createdDate: "2022-09-19T08:29:35.697+00:00",
    updatedUserId: "60fdf891-e47c-4315-860d-eb1ba962b37a",
    updatedUserUsername: "superadmin",
    updatedUserFullname: "Super Admin",
    updatedUserEmail: "superadmin@cityline.com.hk",
    updatedDate: "2022-10-20T03:37:19.436+00:00",
    version: 5,
    roleId: "8fe4240e-1db3-48b6-a22b-4840fbcba5e6",
    roleCode: "admin",
    type: "ADMIN",
    roleName: {
        i18nStringMapId: "813115f4-7a01-4fc7-a3ad-a57609f66006",
        i18nStrings: [
            {
                i18nStringId: "cb53ffc8-c072-4f51-a699-7d5f3deeca88",
                locale: "en",
                value: "admin",
            },
            {
                i18nStringId: "bf89af96-cb8a-44e9-b6ee-be2fb97459d9",
                locale: "zh_TW",
                value: "admin",
            },
            {
                i18nStringId: "a5358553-56ec-4e5f-8d58-990175aeb148",
                locale: "zh_CN",
                value: "admin",
            },
        ],
    },
    remarks: "admin",
    permissionSets: [
    ],
}

@Injectable()
export class MockRoleService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: RoleSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<Role>> {

        let pageResponse = new PageResponse<Role>();
        pageResponse.content = [].concat(itemOne);
        pageResponse.totalElements = 2;
        pageResponse.number = 0;
        pageResponse.size = 2;
        pageResponse.totalPages = 1;

        return of(pageResponse);
    }

    insert(role: Role): Observable<Role> {

        let body = JSON.stringify(role);

        return of(itemOne)

    }

    get(id: string): Observable<Role> {
        return of(itemOne)
    }

    update(role: Role): Observable<Role> {
        return of(itemOne)

    }

    getRoleByType(roleType: RoleType): Observable<Role[]> {

        return of(itemOne)
    }
}